module.exports = __webpack_public_path__ + "img/heart-circle-minus-sharp-light.ad35fb21.svg";